import { Modal } from "react-bootstrap";
import * as React from "react";

interface ConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmButtonText: string;
    cancelButtonText?: string;
}

function ConfirmationModal({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmButtonText,
    cancelButtonText = "Cancel",
}: ConfirmationModalProps) {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal
            show={open}
            onHide={onClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header
                closeButton
                className="m-0 p-5"
            >
                <h6>{title}</h6>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer className="p-0">
                <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={onClose}
                >
                    {cancelButtonText}
                </button>
                <button
                    type="button"
                    className="btn btn-danger m-2 btn-sm"
                    onClick={handleConfirm}
                >
                    {confirmButtonText}
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;